import { createFileRoute } from "@tanstack/react-router";

import HouseRulesPage from "@/admin/settings/house-rules/page";

export const Route = createFileRoute("/app/$storeId/settings/house-rules")({
    component: RouteComponent,
});

function RouteComponent() {
    return <HouseRulesPage />;
}
